// import { StyledSwitch } from './Switch.styles'
import { Switch, type SwitchProps } from '@mantine/core'
import React from 'react'

export const NewSwitch = ({ ...props }: SwitchProps) => {
  return <Switch {...props} />
}

export default NewSwitch
